<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/7chap1#chap1">1. Of Dragons, Mountains, Transhumance, Sequence, and Sunken Cities, <i>or</i>: The Violence of the Letter</a></p>
<p class="toc1"><a href="#/8chap2#chap2">2. Of Roads, Real Cities, Streets, and Strangers</a></p>
<p class="toc1"><span href="#/9chap3#chap3" title="Link target outside of Sample">3. Of Markets, Maps, Cellars, and Cisterns</span></p>
<p class="toc1"><span href="#/10chap4#chap4" title="Link target outside of Sample">4. Of Fate, Fortune, Mayhem, and Mystery</span></p>
<p class="toc1"><span href="#/11chap5#chap5" title="Link target outside of Sample">5. Of Matrons, Mornings, Motives, and Machinations</span></p>
<p class="toc1"><span href="#/12chap6#chap6" title="Link target outside of Sample">6. Of Falls, Fountains, Notions, and New Markets</span></p>
<p class="toc1"><span href="#/13chap7#chap7" title="Link target outside of Sample">7. Of Commerce, Capital, Myths, and Missions</span></p>
<p class="toc1"><span href="#/14chap8#chap8" title="Link target outside of Sample">8. Of Models, Mystery, Moonlight, and Authority</span></p>
<p class="toc1"><span href="#/15chap9#chap9" title="Link target outside of Sample">9. Of Night, Noon, Time, and Transition</span></p>
<p class="toc1"><span href="#/16chap10#chap10" title="Link target outside of Sample">10. Of Bronze, Brews, Dragons, and Dinners</span></p>
<p class="toc1"><span href="#/17chap11#chap11" title="Link target outside of Sample">11. Of Family Gatherings, Grammatology, More Models, and More Mysteries</span></p>
<p class="toc1"><span href="#/18chap12#chap12" title="Link target outside of Sample">12. Of Models, Monsters, Night, and the Numinous</span></p>
<p class="toc1"><span href="#/19chap13#chap13" title="Link target outside of Sample">13. Of Survival, Celebration, and Unlimited Semiosis</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/20chap14#chap14" title="Link target outside of Sample">Appendix A: The Culhar’ Correspondence</span></p>
<p class="toc1"><span href="#/21chap15#chap15" title="Link target outside of Sample">Appendix B: Acknowledgments</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/22preview#preview" title="Link target outside of Sample">Preview: <i>Flight from Nevèrÿon</i></span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/28biography#biography" title="Link target outside of Sample">A Biography of Samuel R. Delany</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5TOC.vue?5e58510b